import React from "react";
import { FooterContainer } from "./styles";
import { Flex } from "antd";
import { FacebookOutlined, InstagramOutlined, TwitterOutlined, LinkedinOutlined, YoutubeOutlined } from '@ant-design/icons';
import { useSelection } from "../../context/selection/selectionProvider";

function Footer() {
    const { setUseTermModal } = useSelection(); 
    return (
        <FooterContainer>
            <head>
                <div className="logo-footer">
                    <a href="https://www.dataprev.gov.br/" target="_blank" rel="noopener noreferrer">
                        <img
                            src="/assets/images/logodatapreve.png"
                            alt="logotipo da Ideia X"
                        />
                    </a>
                    <Flex className="social-nav" style={{flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                        <h4>
                            REDES SOCIAIS
                        </h4>
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/dataprevtecnologia" target="_blank" rel="noopener noreferrer">
                                    <FacebookOutlined style={{ fontSize: '24px', color: 'white' }} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/dataprev" target="_blank" rel="noopener noreferrer">
                                    <InstagramOutlined style={{ fontSize: '24px', color: 'white' }} />
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/dataprev?mx=2" target="_blank" rel="noopener noreferrer">
                                    <TwitterOutlined style={{ fontSize: '24px', color: 'white' }} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/dataprev-tecnologia/" target="_blank" rel="noopener noreferrer">
                                    <LinkedinOutlined style={{ fontSize: '24px', color: 'white' }} />
                                </a>
                            </li>
                            <li>
                                <a href="https://www.youtube.com/user/DataprevTecnologia" target="_blank" rel="noopener noreferrer">
                                    <YoutubeOutlined style={{ fontSize: '24px', color: 'white' }} />
                                </a>
                            </li>
                        </ul>
                    </Flex>
                </div>
            </head>
            <section>
                <nav>
                    <ul>
                        <li onClick={() => setUseTermModal(true)}>Termos de uso</li>
                        <li>
                            <a href="https://www.dataprev.gov.br/politica-de-seguranca-da-informacao-e-privacidade" target="_blank" rel="noopener noreferrer">
                                Política de privacidade
                            </a>
                        </li>
                    </ul>
                </nav>
                <span>© IDEIA X {new Date().getFullYear()} - Versão 2.0.0</span>
            </section>
        </FooterContainer>
    );
}

export default Footer;
